import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import Overlay from 'components/Overlay/Overlay';

import './LoadingOverlayLayout.scss';

/* istanbul ignore next */
export const mapStateToProps = (state, ownProps) => ({
  isLoading: ownProps.isLoading === undefined ? !!state.appState.get(ownProps.loadingKey, '') : ownProps.isLoading,
});

export class LoadingOverlayLayout extends Component {
  static propTypes = {
    isLoading: PropTypes.bool,
    children: PropTypes.node.isRequired,
    loadingKey: PropTypes.string,
  };

  static defaultProps = {
    isLoading: false,
    loadingKey: 'loadingState',
  };

  render() {
    const { isLoading, children } = this.props;

    return (
      <div className="loading-overlay-layout">
        { isLoading && <Overlay loadingState="spinning" /> }
        { children }
      </div>
    );
  }
}

export default connect(mapStateToProps)(LoadingOverlayLayout);



/** WEBPACK FOOTER **
 ** ./src/layouts/LoadingOverlayLayout/LoadingOverlayLayout.jsx
 **/